import environment from '@/environment';
import VueRouter from 'vue-router';

import analytics from '@segment/analytics.js-core';
import SegmentIntegration from '@segment/analytics.js-integration-segmentio';
import { UserProfile } from '../interfaces';
import store, { smartRootModule } from '@/main/baseStore';
import { getPlatformDetails } from '@/api/providers/platform.provider';

analytics.use(SegmentIntegration);

const useAnalytics = Boolean(environment.segmentApiKey);
const integrationSettings = {
    'Segment.io': {
        apiKey: environment.segmentApiKey,
        retryQueue: true,
        addBundledMetadata: true,
        unbundledIntegrations: ['Mixpanel'],
    },
};
if (useAnalytics) {
    getPlatformDetails(window.location.host).then(platform => {
        if (!platform.is_internal) analytics.initialize(integrationSettings);
    });
}

export const segmentIdentify = (user: UserProfile) => {
    if (!useAnalytics || !user.analyticsEnabled) {
        return;
    }
    analytics.identify(`${user.platformId}:${user.id}`, {
        name: `${user.firstName} ${user.lastName}`,
    });
};

export const segmentPage = () => {
    const analyticsEnabled = () =>
        smartRootModule.context(store).modules.userProfileDetails.state.authUserProfile?.analyticsEnabled ?? true;

    if (!useAnalytics || !analyticsEnabled()) {
        return;
    }
    analytics.page();
};

export const includeSavePageInSegment = (router: VueRouter) => {
    router.beforeEach((_to, _from, next) => {
        segmentPage();
        return next();
    });
};
